import axios from "@/plugins/axios";
import utils from "@/stores/utils";
import invitations from "./submodules/invitations";

import { invitationQueries, invitationEmail, mergeInvitationMatches } from "@/utils/customer-invitation";

let searchVersion = 0;
const state = {
    search: null,
    searching: false,
    searching_errors: false,
    results: [],
    entity: null,
    customer: null,
    usemail: false,
    email: null,
    name: null,
    customer_inviting: false,
    message: null,
};

const mutations = {
    updateSearch(state, search) {
        searchVersion += 1;
        state.search = search;
    },
    updateSearching(state, saving) {
        state.searching = saving;
    },
    updateSearchingErrors(state, errors) {
        state.searching = false;
        state.searching_errors = errors;
    },
    updateResults(state, results) {
        state.results = results;
    },
    updateEntity(state, entity) {
        state.entity = entity;
        if (entity) {
            state.name = entity.name;
        }
    },
    updateCustomer(state, customer) {
        state.customer = customer;
    },
    updateUsemail(state, usemail) {
        state.usemail = usemail;
    },
    updateEmail(state, email) {
        state.email = email;
    },
    updateName(state, name) {
        state.name = name;
    },
    updateCustomerInviting(state, saving) {
        state.customer_inviting = saving;
    },
    updateMessage(state, message) {
        state.message = message;
    },

};

const actions = {

    async searchCustomer({ commit, state }, params = {}) {
        const version = ++searchVersion;
        const queries = params.automatic ? invitationQueries(state.customer) : [state.search?.trim()].filter(Boolean);
        commit("updateSearchingErrors", null);
        commit("updateSearching", true);
        try {
            const responses = await Promise.all(queries.map(search => axios.get("/api/searchentities/", { params: { search } })));
            if (version !== searchVersion) return;
            commit("updateResults", mergeInvitationMatches(responses.map(response => response.data)));
        } catch (error) {
            if (version !== searchVersion) return;
            commit("updateResults", []);
            commit("updateSearchingErrors", "La recherche a échoué. Réessayez avant de poursuivre.");
        } finally {
            if (version === searchVersion) commit("updateSearching", false);
        }
    },


    async inviteCustomer({ commit, dispatch, state }, params) {
        try {
            commit("updateCustomerInviting", true);
            if (state.customer?.id) {
                const response = await axios.patch(`/api/customers/${state.customer.id}/`, {
                    email_or_safetee_id: state.entity?.safetee_id || state.email,
                });
                return response.data;
            }
            const response = await axios.post("/api/customers/", {
                name: state.customer?.name || state.name,
                email_or_safetee_id: state.entity?.safetee_id || state.email,
            });
            return response.data;
        } catch (xhr_error) {
            let errors = utils.handleError(xhr_error);
            throw errors
        } finally {
            commit("updateCustomerInviting", false);
        }
    },



    async init({ commit, dispatch, state }, params) {
        commit("updateSearch", params?.customer?.name);
        commit("updateEmail", invitationEmail(params?.customer));
        commit("updateName", null);
        commit("updateUsemail", false);
        commit("updateResults", []);
        commit("updateEntity", params.entity);
        commit("updateCustomer", params.customer);
        await dispatch('searchCustomer', { automatic: true });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        invitations: invitations(),
    }
};
